import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { LogoFull } from '../components/Logo';
import api from '../lib/api';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return toast.error('La contraseña debe tener al menos 8 caracteres.');
    if (pw !== pw2) return toast.error('Las contraseñas no coinciden.');
    setSubmitting(true);
    try {
      await api.post('/auth/reset-password', { token, new_password: pw });
      setDone(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'No pudimos actualizar la contraseña.');
    } finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col p-8 lg:p-14">
      <div className="flex items-center">
        <LogoFull height={30} />
      </div>
      <div className="flex-1 flex items-center">
        <div className="w-full max-w-md mx-auto">
          <h1 className="text-3xl font-semibold text-[#1C2329] tracking-tight">Nueva contraseña</h1>
          {!token ? (
            <div className="mt-6 p-4 border border-[#FCA5A5] bg-[#FEF2F2] text-[13px] text-[#991B1B]">
              Enlace inválido. <Link to="/forgot-password" className="underline">Solicite uno nuevo</Link>.
            </div>
          ) : done ? (
            <div className="mt-6 p-5 border border-[#A7F3D0] bg-[#ECFDF5] flex items-start gap-2" data-testid="reset-done">
              <CheckCircle2 size={18} className="text-[#065F46] mt-0.5" />
              <div className="text-[14px] text-[#065F46]">
                Contraseña actualizada. Redirigiéndolo al inicio de sesión…
              </div>
            </div>
          ) : (
            <form onSubmit={onSubmit} className="mt-8 space-y-4" data-testid="reset-form">
              <div>
                <label className="block text-[12px] font-medium text-[#374151] mb-1.5 uppercase tracking-wider">Nueva contraseña</label>
                <input type="password" value={pw} onChange={(e) => setPw(e.target.value)}
                  className="pv-input" required minLength={8} autoComplete="new-password"
                  data-testid="reset-pw" />
              </div>
              <div>
                <label className="block text-[12px] font-medium text-[#374151] mb-1.5 uppercase tracking-wider">Repita la contraseña</label>
                <input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)}
                  className="pv-input" required minLength={8} autoComplete="new-password"
                  data-testid="reset-pw2" />
              </div>
              <button type="submit" disabled={submitting}
                className="pv-btn-primary w-full flex items-center justify-center gap-2 disabled:opacity-50"
                data-testid="reset-submit">
                {submitting ? 'Guardando…' : 'Actualizar contraseña'}
                {!submitting && <ArrowRight size={16} strokeWidth={1.75} />}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
